<template>
    <div>
        <el-form ref="deprAdjust" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">调整类型</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="adjustType">
                            <el-select v-model="adjustType" placeholder="请选择">
                                <el-option v-for="deprAdjustType in deprAdjustTypeList" :label="deprAdjustType.text" :value="deprAdjustType.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="hint block" v-if="adjustType == 0">
                <div class="title">基础信息</div>
                <p>可以调整 1、原值，2、使用年限，3、起算日期，4、残值率</p>
            </div>
            <div class="hint block" v-if="adjustType == 1">
                <div class="title">当月折旧</div>
                <p>最后/当月折旧值，要回退，重新计算累计折旧</p>
            </div>
            <div class="hint block" v-if="adjustType == 2">
                <div class="title">历史重算</div>
                <p>可以调整 1、原值，2、使用年限，3、起算日期，4、残值率</p>
                <p>指定从某个月份/起始月份重新算起</p>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, Routes, MsgBox } from '../../app.vues'

    export default {
        name: 'swb-depr-adjust-type-select',
        desc: '调整类型选择',
        props: ['type'],
        data: function () {
            return {
                adjustType: null,
                deprAdjustTypeList: []
            }
        },
        created: function () {
            this.deprAdjustTypeList = getEnumList("deprAdjustType"); // 资产调整类型
            if(!Utils.isNoB(this.type)) {
                this.adjustType = this.type;
            }
        },
        methods: {
            getDlgResult() {
                let adjustType = this.adjustType;
                let result = {};
                if(Utils.isNoB(adjustType)) {
                    result.type = "warn";
                    result.message = "请选择调整类型";
                } else {
                    result.type = "info";
                    result.data = adjustType;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetFiscal/DeprAdjustTypeSelect.vue